export default __webpack_public_path__ + "6499f4887751b0c0b1459e57e0753937.jpg";